import { configureAutoTrack, record } from "@aws-amplify/analytics";
import { Amplify } from "aws-amplify";

fetch("/config").then((response) => {
  if (response.ok) {
    response.json().then((config) => {
      Amplify.configure({
        Auth: {
          Cognito: {
            identityPoolId: config.identityPoolId,
            allowGuestAccess: true,
          },
        },
        Analytics: {
          Pinpoint: {
            appId: config.pinpointAppId,
            region: "eu-west-1",
          },
        },
      });

      // Get the 'ref' query parameter
      const urlParams = new URLSearchParams(window.location.search);
      const refParam = urlParams.get("ref");

      record({
        name: "pageView",
        attributes: {
          url: window.location.href,
          referrer: refParam || document.referrer || "direct",
        },
      });

      // Remove the 'ref' parameter from the URL
      if (refParam) {
        urlParams.delete("ref");
        const newUrl =
          window.location.pathname +
          (urlParams.toString() ? `?${urlParams.toString()}` : "") +
          window.location.hash;
        window.history.replaceState({}, document.title, newUrl);
      }
    });
  }
});
